export default __webpack_public_path__ + "static/media/ars-maquette-light-webfont.638f6349.woff";